import * as React from 'react';

import ReactMarkdown from 'react-markdown';
import { AssistantMessageProps } from '@copilotkit/react-ui';

import { Spinner, Text } from '@components/common';
import { ClockRefreshSVG, CopySVG, LogoSVG, ThumbsDownSVG, ThumbsUpSVG } from '@components/svgs';
import { noop } from '@components/utils';

export const AssistantMessage = ({ message, isGenerating, onCopy, onRegenerate }: AssistantMessageProps) => {
  if (!message) return null;
  if (isGenerating) return null;
  if (typeof message === 'object' && Object.keys(message).length === 0) return null;

  return (
    <div className='py-4'>
      <div className='flex items-center space-x-2'>
        <LogoSVG className='h-6 w-6 rounded-full border border-gray-200 text-indigo-600' />
        <Text bold h='400'>
          Great Question
        </Text>
      </div>
      {message ? (
        <>
          <Text h='400' className='mt-2'>
            <ReactMarkdown
              components={{
                a: ({ node, children, ...props }) => (
                  <a target='_blank' rel='noopener noreferrer' {...props}>
                    {children || props.href}
                  </a>
                ),
                code: ({ node, className, children, ...props }) => {
                  const match = /language-(\w+)/.exec(className || '');
                  return match ? (
                    <code className={className} {...props}>
                      {children}
                    </code>
                  ) : (
                    <code className='rounded bg-gray-100 px-1 py-0.5' {...props}>
                      {children}
                    </code>
                  );
                }
              }}
            >
              {message}
            </ReactMarkdown>
          </Text>
          <div className='mt-2 flex items-center space-x-4'>
            <button onClick={noop} className='text-gray-400 hover:text-gray-600'>
              <ThumbsUpSVG className='h-4 w-4' />
            </button>
            <button onClick={noop} className='text-gray-400 hover:text-gray-600'>
              <ThumbsDownSVG className='h-4 w-4' />
            </button>
            <button onClick={() => onCopy?.(message)} className='text-gray-400 hover:text-gray-600'>
              <CopySVG className='h-4 w-4' />
            </button>
            <button onClick={onRegenerate} className='text-gray-400 hover:text-gray-600'>
              <ClockRefreshSVG className='h-4 w-4' />
            </button>
          </div>
        </>
      ) : (
        <Spinner className='mt-2 h-4 w-4' />
      )}
    </div>
  );
};
